/** @jsx jsx */
import { jsx } from "theme-ui";
import { useSelector } from "react-redux";
import { selectorSrcmProfile } from "../state/selectors";
import { Login as L } from "../components/Login";
import { Modal } from "../components/Modal";

const SignedInSection = ({ children = null }) => {
  const srcmProfile = useSelector(selectorSrcmProfile);

  if (!srcmProfile) {
    return (
      <Modal>
        <L />
      </Modal>
    );
  }
  return children;
};

export default SignedInSection;
